export default __webpack_public_path__ + "static/media/warning3.52bacbbd.jpg";